<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>费用看板</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isShowDetails = false">临时工</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isShowDetails">
      <section class="searchBox">
        <span>
          <label>一级项目：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo">
          <label>省级项目：</label>
          <a-select
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <a-select style="width: 140px" v-model="status">
            <!-- <a-select-option :value="10">待项目经理审核</a-select-option>
            <a-select-option :value="21">项目经理驳回</a-select-option>
            <a-select-option :value="20">待项目总监审核</a-select-option>
            <a-select-option :value="31">项目总监驳回</a-select-option>
            <a-select-option :value="40">待打款</a-select-option>
            <a-select-option :value="41">出纳驳回</a-select-option>
            <a-select-option :value="50">结算完成</a-select-option> -->
            <a-select-option :value="10">待项目经理审核</a-select-option>
            <a-select-option :value="11">项目经理驳回</a-select-option>
            <a-select-option :value="200">待项目总监审核</a-select-option>
            <a-select-option :value="210">项目总监驳回</a-select-option>
            <a-select-option :value="20">待项目负责人审核</a-select-option>
            <a-select-option :value="21">项目负责人驳回</a-select-option>
            <a-select-option :value="30">待财务审核</a-select-option>
            <a-select-option :value="31">财务驳回</a-select-option>
            <a-select-option :value="40">待打款</a-select-option>
            <a-select-option :value="41">出纳驳回</a-select-option>
            <!-- <a-select-option :value="42">已出账</a-select-option> -->
            <a-select-option :value="50">结算完成</a-select-option>
            <a-select-option :value="60">支付宝支付失败</a-select-option>
            <!-- <a-select-option :value="100">已作废</a-select-option> -->
          </a-select>
        </span>
        <span>
          <label>支付宝状态：</label>
          <a-select style="width: 140px" v-model="payment_status">
            <a-select-option :value="10">待执行</a-select-option>
            <a-select-option :value="20">预执行</a-select-option>
            <a-select-option :value="30">支付成功</a-select-option>
            <a-select-option :value="40">支付失败</a-select-option>
          </a-select>
        </span>
        <span>
          <label>结算方式：</label>
          <a-select
            :allowClear="true"
            style="width: 140px; margin-right: 6px"
            v-model="paytype"
          >
            <a-select-option :value="1">支付宝</a-select-option>
            <a-select-option :value="2">银行卡</a-select-option>
          </a-select>
        </span>
        <span>
          <label>结算月：</label>
          <a-month-picker @change="selectMonth" v-model="monthVal" />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width: 210px"
            placeholder="编号|姓名|手机号"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button
            type="primary"
            icon="search"
            style="margin-right: 10px"
            @click="onSearch"
            >搜索</a-button
          >

          <a-button @click="onDownload" class="resetStyle">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <div class="money-all" v-if="count_data.total_amount">
          费用金额总计：<span class="money-num">{{
            Number(count_data.total_amount)
          }}</span>
        </div>
        <a-table
          :columns="columns"
          :data-source="tabledata"
          :pagination="false"
          size="middle"
          bordered
          :scroll="{ x: 1500 }"
          :rowKey="record => record.xrg_id"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="detailsPage(record)">详情</a>
          </span>
        </a-table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <calculationDetails v-show="isShowDetails" :detailsVal="detailsVal" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import calculationDetails from "@/components/money/calculationDetails";
const columns = [
  {
    title: "提交时间",
    dataIndex: "create_time",
    align: "right",
    width: 200
  },
  {
    title: "结算月",
    dataIndex: "month",
    align: "right",
    width: 100
  },
  {
    title: "员工",
    dataIndex: "guard_user_name",
    align: "right",
    width: 80
  },
  {
    title: "项目",
    dataIndex: "project_name",
    align: "right",
    width: 200
  },
  {
    title: "岗位",
    dataIndex: "role_names",
    align: "right",
    width: 100
  },
  {
    title: "甲方单价",
    dataIndex: "first_price",
    align: "right",
    width: 100
  },
  {
    title: "打包单价",
    dataIndex: "pack_price",
    align: "right",
    width: 100
  },
  {
    title: "员工单价",
    dataIndex: "guard_price",
    align: "right",
    width: 100
  },
  {
    title: "三方单价",
    dataIndex: "three_price",
    align: "right",
    width: 100
  },
  {
    title: "工时/件数",
    dataIndex: "hours",
    align: "right",
    width: 100
  },
  {
    title: "费用金额",
    dataIndex: "guard_amount",
    align: "right",
    width: 100
  },
  {
    title: "结算通道",
    dataIndex: "paytype",
    align: "right",
    width: 100,
    customRender: (paytype, record) => {
      if (paytype == 1) {
        return "支付宝";
      } else if (paytype == 2) {
        return "银行卡";
      }
    }
  },
  {
    title: "状态",
    dataIndex: "status",
    align: "right",
    width: 150,
    customRender: (status, record) => {
      // text参数为当前行的值；record参数为当前行数据
      if (status == 10) {
        return "待项目经理审核";
      } else if (status == 11) {
        return "项目经理驳回";
      } else if (status == 20) {
        return "待项目总监审核";
      } else if (status == 21) {
        return "项目总监驳回";
      } else if (status == 30 && record.xf_status == 20) {
        return "待项目负责人审核";
      } else if (status == 30 && record.xf_status == 21) {
        return "项目负责人驳回";
      } else if (status == 30 && record.xf_status == 30) {
        return "待财务审核";
      } else if (status == 30 && record.xf_status == 31) {
        return "财务驳回";
      } else if (status == 30 && record.xf_status == 40) {
        return "待出纳审核";
      } else if (status == 30 && record.xf_status == 41) {
        return "出纳驳回";
      } else if (status == 30 && record.xf_status == 42) {
        return "部分打款";
      } else if (status == 30 && record.xf_status == 50) {
        return "结算完成";
      } else if (status == 30 && record.xf_status == 100) {
        return "费用作废";
      } else if (status == 30 && record.xf_status == 60) {
        return "支付宝支付失败";
      }
    }
  },
  {
    title: "支付宝状态",
    dataIndex: "payment_status",
    align: "right",
    width: 150,
    customRender: (status, record) => {
      // text参数为当前行的值；record参数为当前行数据
      if (status == 10) {
        return "待执行";
      } else if (status == 20) {
        return "预执行";
      } else if (status == 30) {
        return "支付成功";
      } else if (status == 40) {
        return "支付失败";
      } 
    }
  },
  {
    title: "操作",
    width: 90,
    align: "center",
    fixed: "right",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  data() {
    return {
      columns,
      tabledata: [],
      loading: false,
      page: 1,
      pagination: {},
      totalPage: Number,
      thList: [
        "提交时间",
        "员工",
        "项目",
        "岗位",
        "结算月",
        "费用金额",
        "状态",
        "操作"
      ],
      proList: [],
      project_id: "",
      isShowDetails: false,
      detailsVal: {},
      status: "",
      query_field: "",
      month: "",
      monthVal: moment().startOf("month").format("YYYY-MM"),
      count_data: "",
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      paytype: "",
      payment_status: "",
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    calculationDetails
  },
  mounted() {
    this.month = this.monthVal;
    this.getData(); //获取列表
    this.getPro(); //获取项目
    this.getProOne(); //获取一级项目列表
  },
  watch: {},
  methods: {
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    selectMonth(date, dateString) {
      this.month = dateString;
    },
    onDownload() {
      console.log(this.paytype)
      let status = "",
        xf_status = "";
      if (
        this.status == 10 ||
        this.status == 11 ||
        this.status == 200 ||
        this.status == 201
      ) {
        xf_status = "";
        switch (this.status) {
          case 10:
            status = this.status;
            break;
          case 11:
            status = this.status;
            break;
          case 200:
            status = 20;
            break;
          case 201:
            status = 21;
            break;
        }
      } else {
        status = "";
        xf_status = this.status;
      }
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/daySettlementRelationListsDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&project_id=" +
        pro +
        "&query_field=" +
        this.query_field +
        "&status=" +
        status +
        "&xf_status=" +
        xf_status +
        "&month=" +
        this.month +
        "&paytype=" +
        this.paytype +
        "&payment_status=" +
        this.payment_status;
    },
    detailsPage(val) {
      this.isShowDetails = true;
      this.detailsVal = val;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.tabledata = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/daySettlementRelationLists";
      let status = "",
        xf_status = "";
      if (
        this.status == 10 ||
        this.status == 11 ||
        this.status == 200 ||
        this.status == 201
      ) {
        xf_status = "";
        switch (this.status) {
          case 10:
            status = this.status;
            break;
          case 11:
            status = this.status;
            break;
          case 200:
            status = 20;
            break;
          case 201:
            status = 21;
            break;
        }
      } else {
        status = "";
        xf_status = this.status;
      }
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      axios
        .post(url, {
          payment_status: this.payment_status,
          paytype: this.paytype,
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          project_id: pro,
          status: status,
          xf_status: xf_status,
          month: this.month,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.count_data = res.data.data.count_data;
            // console.log(this.data);
            this.tabledata = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.payment_status = "";
      this.paytype = "";
      this.project_id = "";
      this.query_field = "";
      this.status = "";
      this.month = "";
      this.modelValue = "";
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.getPro(); //获取项目
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }
}
.money-all {
  text-align: right;
  margin-bottom: 6px;

  .money-num {
    font-size: 28px;
    color: red;
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
